import BusinessInsights from './BusinessInsights';

export default BusinessInsights;
